export const costs = [
  'Noches en vela buscando cómo traducir conceptos de meteorología complejos a un lenguaje que tus alumnos puedan entender.',
  'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo.',
  'Alumnos desconectados que sienten que la meteorología no tiene nada que ver con ellos ni con su realidad cotidiana.',
  'Silencios incómodos cuando un alumno pregunta cómo se forma un tornado o qué es la presión atmosférica y no tienes una respuesta clara a mano.',
  'Fines de semana perdidos armando planificaciones, proyectos meteorológicos y evaluaciones desde cero una y otra vez.',
  'Incertidumbre sobre cómo enseñar circulación atmosférica, análisis de situaciones sinópticas o riesgos meteorológicos sin los recursos adecuados.',
];
